const GET_EL_HEIGHTS = 'parallaxStatus/GET_EL_HEIGHTS'

export const getElHeights = (payload) => ({
  type: GET_EL_HEIGHTS,
  payload: payload,
})
type ElHeightsAction = ReturnType<typeof getElHeights>
type ElHeightsState = {
  parallax: Object
}
export const initialState: ElHeightsState = {
  parallax: {},
}

export default function parallaxStatus(
  state: ElHeightsState = initialState,
  action: ElHeightsAction,
) {
  switch (action.type) {
    case GET_EL_HEIGHTS:
      return {
        ...state,
        parallax: action.payload,
      }

    default:
      return state
  }
}
